import { render, staticRenderFns } from "./VuePinchZoom.vue?vue&type=template&id=71d17128&"
import script from "./VuePinchZoom.vue?vue&type=script&lang=js&"
export * from "./VuePinchZoom.vue?vue&type=script&lang=js&"
import style0 from "./VuePinchZoom.vue?vue&type=style&index=0&id=71d17128&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports